/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Born_Happy_Mantis_AgreeInputs */

const fr_born_happy_mantis_agree = /** @type {(inputs: Born_Happy_Mantis_AgreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masquer`)
};

/**

* @param {Born_Happy_Mantis_AgreeInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const born_happy_mantis_agree = /** @type {((inputs?: Born_Happy_Mantis_AgreeInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Born_Happy_Mantis_AgreeInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_born_happy_mantis_agree(inputs)
});